import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
// ECharts optimized imports for tree shaking
import * as echarts from 'echarts/core';
import {
  BarChart as EChartsBarChart
} from 'echarts/charts';
import {
  TooltipComponent,
  TitleComponent,
  GridComponent
} from 'echarts/components';
import {
  CanvasRenderer
} from 'echarts/renderers';
import { ThemeService } from '../../service/theme-service';

// Register the required components
echarts.use([
  EChartsBarChart,
  TooltipComponent,
  TitleComponent,
  GridComponent,
  CanvasRenderer
]);


@Component({
  selector: 'app-paper-bar-chart',
  standalone:false,
  templateUrl: './paper-bar-chart.html',
  styleUrls: ['./paper-bar-chart.scss'],
})
export class PaperBarChart implements OnInit, OnChanges {
  @Input() topicObj!: any;
  @Input() title_array!: string[];
  @Input() count_array!: number[];
  private themeService = inject(ThemeService);
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.initBarChart(this.topicObj, this.title_array, this.count_array);
  }

  ngOnInit() {}
  initBarChart(
    topicObj: any,
    title_array: string[],
    count_array: number[]
  ): void {
    if (title_array.length > 0 && count_array.length > 0) {
      const chartDom = document.getElementById('paper_submission_topic_wise')!;
      const theme = this.themeService.isDark() ? 'dark' : undefined;
      const myChart = echarts.init(chartDom, theme);
      const textColor = this.themeService.isDark() ? '#cbd5e1' : '#333';
      const option = {
        backgroundColor: 'transparent',
        title: {
          text: topicObj.title,
          left: 'center',
          textStyle: { color: textColor }
        },
        tooltip: {},
        xAxis: {
          data: title_array,
          axisLabel: { color: textColor },
          axisLine: { lineStyle: { color: this.themeService.isDark() ? '#475569' : '#ccc' } }
        },
        yAxis: {
          axisLabel: { color: textColor },
          axisLine: { lineStyle: { color: this.themeService.isDark() ? '#475569' : '#ccc' } },
          splitLine: { lineStyle: { color: this.themeService.isDark() ? '#334155' : '#eee' } }
        },
        series: [
          {
            name: topicObj.series_name,
            type: 'bar',
            data: count_array,
          },
        ],
      };
      myChart.setOption(option);
    }
  }
}
